/**
 * Gets the first letter of each word in the text up to n.
 * If n is less than the total number of words, use more letters.
 *
 * ### Example
 * ```js
 * import { initials } from '@tsyl/radon'
 * console.log(initials('Hello World'))
 * // => HW
 * ```
 *
 * @param txt - Full text from which to obtain the initials.
 * @param n - Number of letters.
 * @returns The initials uppercase
 */
export function initials(txt, n = 2) {
    if (!txt)
        return txt;
    const splittedName = txt.split(' ');
    const worldsTaken = n / splittedName.length;
    const initials = [];
    for (let i = 0; i < n; i++) {
        if (splittedName[i]) {
            for (let j = 0; j < worldsTaken; j++) {
                if (splittedName[i][j])
                    initials.push(splittedName[i][j]);
            }
        }
    }
    return initials.join('').substring(0, n).toUpperCase();
}
/**
 * Replace string with params like C#
 *
 * ### Example
 * ```js
 * import { formatString } from '@tsyl/radon'
 * const result = formatString('My name is {0}, {1} {0}.', 'Bond', 'James')
 * console.log(result)
 * // => My name is Bond, James Bond.
 * ```
 *
 * @param string - raw text
 * @param args - items to remplace
 * @returns formatted text
 */
export function formatString(string, ...args) {
    if (args.length === 0) {
        return string;
    }
    for (let i = 0; i < args.length; i++) {
        string = string.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i]);
    }
    return string;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9zdHJpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O0dBY0c7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEdBQVcsRUFBRSxDQUFDLEdBQUcsQ0FBQztJQUN6QyxJQUFJLENBQUMsR0FBRztRQUFFLE9BQU8sR0FBRyxDQUFBO0lBRXBCLE1BQU0sWUFBWSxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDbkMsTUFBTSxXQUFXLEdBQUcsQ0FBQyxHQUFHLFlBQVksQ0FBQyxNQUFNLENBQUE7SUFDM0MsTUFBTSxRQUFRLEdBQUcsRUFBRSxDQUFBO0lBQ25CLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDMUIsSUFBSSxZQUFZLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDbkIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLFdBQVcsRUFBRSxDQUFDLEVBQUUsRUFBRTtnQkFDcEMsSUFBSSxZQUFZLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUFFLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7YUFDMUQ7U0FDRjtLQUNGO0lBQ0QsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7QUFDeEQsQ0FBQztBQUVEOzs7Ozs7Ozs7Ozs7OztHQWNHO0FBRUgsTUFBTSxVQUFVLFlBQVksQ0FBQyxNQUFjLEVBQUUsR0FBRyxJQUFjO0lBQzVELElBQUksSUFBSSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDckIsT0FBTyxNQUFNLENBQUE7S0FDZDtJQUNELEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1FBQ3BDLE1BQU0sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLElBQUksTUFBTSxDQUFDLEtBQUssR0FBRyxDQUFDLEdBQUcsS0FBSyxFQUFFLEdBQUcsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0tBQ3JFO0lBQ0QsT0FBTyxNQUFNLENBQUE7QUFDZixDQUFDIn0=